import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import { initializeMsalInstance } from './auth/msalInstance';
import './styles/globals.css';

// Application Insights is NOT started here — it is gated behind the visitor's
// 'analytics' cookie-consent choice and initialised from CookieConsentMount.
export const createRoot = ViteReactSSG(
  { routes },
  async ({ isClient }) => {
    if (!isClient) return;
    await initializeMsalInstance();
  },
);
